<template>
  <div>
    <kn-jumbotron></kn-jumbotron>
    <b-container fluid class="px-4 pb-5">
      <b-row class="justify-content-center mx-auto" style="max-width: 1400px;">
        <kn-sideMenu></kn-sideMenu>

        <main role="main" class="col-md-9 pl-md-5">
          <div class="content-card text-center d-flex flex-column justify-content-center align-items-center"
            style="min-height: 500px;">
            <i class="fa-solid fa-anchor fa-4x mb-4 not-found-icon"></i>
            <h2 class="error-title mb-3">404 - Δεν Βρέθηκε</h2>
            <p class="error-message mb-4">
              Η σελίδα που αναζητήσατε δεν υπάρχει ή έχει μετακινηθεί.
            </p>
            <router-link to="/" class="btn-primary-custom">
              <i class="fa-solid fa-home mr-2"></i>Επιστροφή στην Αρχική
            </router-link>
          </div>
        </main>
      </b-row>
    </b-container>
    <kn-footer></kn-footer>
  </div>
</template>

<script>
import jumbotron from './jumbotron.vue';
import sideMenu from './sideMenu.vue';
import footer from './footer.vue';

export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-footer": footer
  }
}
</script>

<style lang="scss" scoped>
.content-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(2, 132, 199, 0.1), 0 8px 10px -6px rgba(2, 132, 199, 0.05);
  padding: 3rem;
  margin-bottom: 2rem;
  border-top: 5px solid #0284c7;
}

.not-found-icon {
  color: #bae6fd;
}

.error-title {
  color: #0c4a6e;
  font-weight: 700;
  font-size: 2.5rem;
}

.error-message {
  color: #475569;
  font-size: 1.25rem;
  max-width: 500px;
}

.btn-primary-custom {
  background-color: #0284c7;
  color: white !important;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(2, 132, 199, 0.2);
}

.btn-primary-custom:hover {
  background-color: #0c4a6e;
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(2, 132, 199, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/pageNotFound.vue